import { ReelInit, ReelObject, reelSpinEmitter, SymbolObject } from "./ReelInit";

// import { Sprite } from 'pixi.js';
import {
    Easing,
    Group,
    Tween
} from "tweedle.js";
import { getSpineSymbol, isIdleExist, /*getSymbol,*/ isLandingAnimationExist } from "../../config/getSymbol";
import {
    spinData
} from '../../server/getServerResposesFun';

// import { betValueGlobal } from "../config/GlobalVariableConfig";

import { sound } from "@pixi/sound";

import {
    REEL_NUMBERS,
    SCATTER_ID,
    // NUMBER_OF_SYMBOLS,
    SHOWN_REELS_HEIGHT,
    SYMBOLS_PER_REEL
} from "../../config/reelConfig";

// import { Ui } from "../ui/Ui"
// import { ColorOverlayFilter } from "pixi-filters";
import { Container } from "pixi.js";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal, jurisdictionGlobal } from "../../config/GlobalVariableConfig";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { SoundConstants } from "../../gameClientEvents/soundConstants";



// import { isTurboBtnOn } from "../config/GlobalVariableConfig";
// import { casinoEventEmitter } from "../core/CasinoChannelHandler";

const reelTweenGroup = new Group();
const textTweenGroup = new Group();

// const wildSymbolBackendId = 11;

export class ReelSpin extends ReelInit {

    // private spinData: SpinDataObject;

    // private ui: Ui;

    public running = false;


    protected quickStop = false;
    protected superQuickStop = false;

    private resolveReelsStop: (() => void) | null = null;

    // private isMultPannelOn = false;

    constructor() {
        super();

        this.quickStop = isQuickBtnOnGlobal;
        this.superQuickStop = isSuperQuickBtnOnGlobal;

        this.setSpinTimeJurisdiction();

    }





    protected resetTweenGroup() {
        reelTweenGroup.removeAll();
    }


    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();
        textTweenGroup.update();


    }






    private generateSymbolRemoveArray(currentRespinIndex: number): number[][] {
        // Initialize the 2D array with random values
        // const SYMBOLS_PER_REEL = 3;  // Number of rows
        // const REEL_NUMBERS = 5;      // Number of columns

        const winArray: number[][] = [];
        for (let j = 0; j < REEL_NUMBERS; j++) {
            const col: number[] = [];
            for (let i = 0; i < SYMBOLS_PER_REEL; i++) {
                col.push(0);
            }
            winArray.push(col);
        }


        spinData.respins[currentRespinIndex].cascadePositions?.forEach((winSymbol) => {

            const reelNum: number = winSymbol[0];
            const posNum: number = winSymbol[1];

            // // Mark the position as 1
            winArray[reelNum][posNum] = 1;

        })


        return winArray;
    }




    private markSymbolWin(currentRespinIndex: number): void {

        // please mind the currentRespinIndex-1 because the win symbols of previous respin will be moved up
        const cascadeArray: number[][] = this.generateSymbolRemoveArray(currentRespinIndex - 1);

        // console.log("after markSymbolWin", cascadeArray);

        // console.log(`inside winTemp`);
        // console.log(winArray);
        for (let j = 0; j < this.allReelArray.length; j++) {
            const reelObj: ReelObject = this.allReelArray[j];
            reelObj.symbols.forEach((symbol, i) => {

                // by default isWin is false, but when wild is placed on a symbols isWin become "true", in that case we will treat that symbols as non-win symbol
                if (cascadeArray[j][i] === 1) {//} && !symbol.isWin) {  //mind the order of j & i
                    symbol.isWin = true;
                }
                else {
                    symbol.isWin = false;
                }
            })
        }
        // console.log(this.allReelArray);
    }


    //setDroppingSymbols
    private setDroppingSymbols(reelObj: ReelObject): void {

        // if(reelObj.reelIndex>0) return;

        const symbolsY: number[] = reelObj.symbols.map(symbol => symbol.y);
        const droppingSymbols: SymbolObject[] = [];

        // console.log(symbolsY);

        let winSymbolCount = 0;
        let totalSymbols = reelObj.symbols.length;
        let id = reelObj.symbols.length;


        //search loop for non win symbols
        for (let i = reelObj.symbols.length - 1; i >= 0; i--) {

            const symbol = reelObj.symbols[i];
            if (!symbol.isWin) {

                id--;
                symbol.symbolIndex = id;
                symbol.y = symbolsY[id];  //moveAReelStep2()-> will move symbols from their current location to symbol.y

                droppingSymbols.push(symbol);

            }
        }

        //search loop for winning symbols
        for (let i = reelObj.symbols.length - 1; i >= 0; i--) {

            const symbol = reelObj.symbols[i];
            if (symbol.isWin) {

                winSymbolCount++;

                id--;
                symbol.symbolIndex = id;
                symbol.y = symbolsY[id];


                symbol.view.y = symbolsY[totalSymbols - winSymbolCount] - SHOWN_REELS_HEIGHT - 100; // 50 for slighlty up so that symbols wont visible when come on top
                // also change the texture of symbol in real data

                droppingSymbols.push(symbol);

            }
        }

        // reverse the droppingSymbols and push in reelObj.symbols
        reelObj.symbols = [];
        for (let i = droppingSymbols.length - 1; i >= 0; i--) {
            reelObj.symbols.push(droppingSymbols[i]);
        }



    }

    public async cacadingReels(currentRespinIndex: number): Promise<void> {


        this.markSymbolWin(currentRespinIndex);
        // console.log("after markSymbolWin", this.allReelArray);

        // await new Promise(resolve => setTimeout(resolve, 100));

        this.allReelArray.forEach((reelObj) => {
            this.setDroppingSymbols(reelObj);
        })

        // debugger;

        // console.log("after markSymbolWin", this.allReelArray);

    }


    protected async spinAReel(reelObj: ReelObject, isNewSpin: boolean): Promise<void> {




        // console.log(reelObj.symbols)

        // reelObj.container.visible=true;
        // this.reelOverlayContainer.visible = false;

        // if (currentRespinIndex == 0) {
        if (isNewSpin) {
            // this.isMultPannelOn = false;
            await this.moveAReelStep1(reelObj); /// *********** just to check
        }
        sound.play(SoundConstants.SPIN_REEL,{ volume: 0.3 });


    }


    // Function that returns a promise which resolves when dataFetched is true
    public waitForData(): Promise<void> {
        return new Promise<void>((resolve) => {

            if (spinData.dataFeatched) {
                resolve();
            }

            const checkInterval = setInterval(() => {
                if (spinData.dataFeatched) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100); // Check every 100ms

        });
    }


    public async moveAReelStep1(reelObj: ReelObject): Promise<void> {

        return new Promise<void>((resolve) => {


            reelObj.mask.alpha = 0.5;
            reelObj.container.mask = reelObj.mask;

            reelObj.symbols.forEach((symbol, k) => {

                const initialPos = symbol.y;
                const symbolContainer = symbol.view;

                const tween = new Tween(symbolContainer, reelTweenGroup)
                    .to({ y: initialPos + SHOWN_REELS_HEIGHT }, this.superQuickStop ? 50 : 250)
                    .delay((this.quickStop || this.superQuickStop) ? 0 : 25 * (reelObj.symbols.length - 1 - k))

                    .easing(Easing.Cubic.In)
                    .onComplete(() => {
                        symbolContainer.y = initialPos - SHOWN_REELS_HEIGHT - 50; // 50 for slighlty up so that symbols wont visible when come on top
                        // this.spinReel2(reelObj);
                        reelTweenGroup.remove(tween);

                        if (k == 0) {
                            resolve();
                            return;
                        }
                    })
                    .start();
            })
            //

        })
    }



    protected async moveAReelStep2(reelObj: ReelObject, currentRespinIndex: number, isNewSpin: boolean): Promise<void> {




        const predifinedSymbolData: number[] = spinData.respins[currentRespinIndex].reelSymbols[reelObj.reelIndex];


        reelObj.symbols.forEach((symbol, i) => {

            let id = predifinedSymbolData[i];

            symbol.symbol.alpha = 1;

            if (symbol.id != id) {
                symbol.symbol.destroy();

                const newSym = getSpineSymbol(id);
                symbol.view.addChildAt(newSym, 0);
                symbol.id = id;
                symbol.symbol = newSym;
                symbol.isWin = false;
                symbol.symbolIndex = i;

            }
            else {

                // it was in 8-bit, need to check
                // symbol.symbol.state.setAnimation(0, "static", false); // 
                symbol.isWin = false;
                symbol.symbolIndex = i;

                // if (multVal > 0) {
                //     symbol.multText.text = `${multVal}x`;
                //     symbol.multVal = multVal;
                // }
            }



        });

        // adjust the layering 
        for (let i = 0; i < SYMBOLS_PER_REEL; i++) {
            const symbol = reelObj.symbols.find(symbol => symbol.symbolIndex === i);
            reelObj.container.addChild(symbol.view);
        }



        reelObj.mask.alpha = 0.5;
        reelObj.container.mask = reelObj.mask;

        let isReelStopSoundPlayed = false; // on this particular Reel
        const animationPromises: Promise<void>[] = [];

        reelObj.symbols.forEach((symbol, k) => {
            const targetPos = symbol.y;
            const symbolContainer = symbol.view;


            if (targetPos === symbolContainer.y) {
                // No animation needed, resolve immediately for this symbol
                animationPromises.push(Promise.resolve());
            } else {
                const promise = new Promise<void>((resolve) => {
                    const tween = new Tween(symbolContainer, reelTweenGroup)
                        .to({ y: targetPos }, this.superQuickStop ? 50 : 250)
                        .delay((this.quickStop || this.superQuickStop) ? 0 : 25 * (reelObj.symbols.length - 1 - k))
                        // .onStart(() => {
                        //     if (k == 0) {
                        //         reelObj.mask.alpha = 0.5;
                        //         reelObj.container.mask = reelObj.mask;
                        //     }
                        // })
                        .easing(Easing.Cubic.In)
                        .onComplete(() => {

                            const symbolId: number = symbol.id;

                            if (isLandingAnimationExist(symbolId)) {
                                console.log("landing")
                                if (isIdleExist(symbolId)) {
                                    console.log("idle")
                                    let listener = {
                                        complete: () => {
                                            console.log("landing done")
                                            resolve(); // Resolve the promise when this animation completes
                                            symbol.symbol.state.removeListener(listener);
                                            symbol.symbol.state.setAnimation(0, "idle", true);
                                        }
                                    };

                                    symbol.symbol.state.addListener(listener);
                                    symbol.symbol.state.timeScale = this.superQuickStop ? 2 : 1;
                                } else {
                                    resolve(); // Resolve the promise when this animation completes
                                }
                                symbol.symbol.state.setAnimation(0, "land", false);
                                if (symbolId === GameConstants.WILD_SYMBOL_ID) {
                                    sound.play(SoundConstants.WILD_SYMBOL, { volume: 0.5, speed: this.superQuickStop ? 2 : 1 });
                                    reelSpinEmitter.emit('animateCharacter', 'win_2');
                                }
                            } else {
                                resolve(); // Resolve the promise when this animation completes
                            }

                            reelTweenGroup.remove(tween);

                            if (!isReelStopSoundPlayed) {
                                isReelStopSoundPlayed = true;
                                this.playReelStop(reelObj.reelIndex, isNewSpin);
                            }


                        })
                        .start();
                });

                animationPromises.push(promise);
            }
        });

        // Wait for all animations to complete before resolving the parent promise
        await Promise.all(animationPromises);


        // })
        //
    }



    public resetSymbolPositions() {

        this.allReelArray.forEach((reelObj) => {

            reelObj.symbols.forEach((symbol) => {
                const targetPos = symbol.y;
                const symbolContainer = symbol.view;
                symbolContainer.y = targetPos;

            })

        })
    }

    private playReelStop(reelIndex: number, isNewSpin: boolean) {

        sound.stop(SoundConstants.SPIN_REEL);
        if (!isNewSpin && this.isReelStopSoundPlayed.some(v => v === true)) {
            return;
        }
        if ((this.quickStop || this.superQuickStop) && (this.isReelStopSoundPlayed.some(v => v === true))) {
            return;
        }

        this.isReelStopSoundPlayed[reelIndex] = true;

        let soundName = 'reel_stop';
        const hasAnyScatter = this.newScatters.some(Boolean);
        const hasScatterOnReel = this.newScatters[reelIndex];

        if (isNewSpin) {
            if (this.quickStop || this.superQuickStop) {
                if (hasAnyScatter) {
                    soundName = 'scatter_stop';
                }
            }
            else if (hasScatterOnReel) {
                soundName = 'scatter_stop';
            }
        }
        else if (hasAnyScatter) {
            soundName = 'scatter_stop';
        }

        sound.play(`${soundName}`, { volume: 0.5 });




    }



    private newScatters: boolean[] = Array.from({ length: REEL_NUMBERS }, () => false);
    private isReelStopSoundPlayed: boolean[] = Array.from({ length: REEL_NUMBERS }, () => false);

    protected setReelStopSounds(currentRespinIndex: number, isNewSpin: boolean) {

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.isReelStopSoundPlayed[i] = false;
        }

        this.allReelArray.forEach((reelObj) => {

            let isNewScatterLand = false;
            const predifinedSymbolData: number[] = spinData.respins[currentRespinIndex].reelSymbols[reelObj.reelIndex];

            reelObj.symbols.forEach((symbol, i) => {
                let id = predifinedSymbolData[i];
                if (id == SCATTER_ID) {
                    if (isNewSpin) {
                        sound.play(SoundConstants.SCATTER_SYMBOL, { volume: 1 });
                        isNewScatterLand = true;
                    }
                    else if (symbol.isWin) {
                        isNewScatterLand = true;
                        sound.play(SoundConstants.SCATTER_LAND, { volume: 1 });
                    }
                    // console.log("scatterLand", reelObj.reelIndex, isNewScatterLand);
                }

            })

            this.newScatters[reelObj.reelIndex] = isNewScatterLand;
        })




    }

    public resetSymbolVisibility() {
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            this.allReelArray[reelNum].container.visible = true;

            this.allReelArray[reelNum].symbols.forEach((symbol) => {
                symbol.view.visible = true;
                symbol.view.alpha = 1;
                symbol.view.tint = 0xffffff;
            })

        }
    }

    public reelMove1CompletePromise: Promise<void>;


    public async startReels(currentRespinIndex: number, isNewSpin: boolean, spinStype: string): Promise<void> {

        console.log("inside startReels in class ReelSpin ")

        this.resetSymbolVisibility();
        this.quickStop = isQuickBtnOnGlobal;
        this.superQuickStop = isSuperQuickBtnOnGlobal;



        this.resetTweenGroup()


        let moveStep1CompleteResolve!: () => void;
        // Initialize moveStep1Complete as a new promise
        this.reelMove1CompletePromise = new Promise<void>((resolve) => {
            moveStep1CompleteResolve = resolve;
        });


        const promises: Promise<void>[] = [];

        this.allReelArray.forEach((reelObj, i) => {
            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.spinAReel(reelObj, isNewSpin).then(resolve);
                    clearTimeout(timeoutId);
                }, (isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : i * 100) : 0));
            });
            promises.push(promise);
        });

        await Promise.all(promises);

        // Resolve moveStep1Complete when this line is reached
        moveStep1CompleteResolve();

        await this.waitForData();
        reelSpinEmitter.emit(EventConstants.SPIN_STEP_DONE);

        if (spinData.respins[currentRespinIndex].type == "reveal" || spinData.respins[currentRespinIndex].type == "fs_reveal") {
            // this.updateGameMultiplier();
        }



        //here is the scatter landing sound play logic
        this.setReelStopSounds(currentRespinIndex, isNewSpin);
        // console.log("scatterLand newScatters", this.newScatters);


        const promises2: Promise<void>[] = [];
        this.allReelArray.forEach((reelObj) => {

            const jurisdictionDelay = isNewSpin ? ((this.quickStop || this.superQuickStop) ? 0 : (reelObj.reelIndex) * (100 + (spinStype === "BASE" ? this.spinTime : 0))) : 0;
            // (total_time - 1250)/5
            // for 5000ms value will be (5000-1250)/5 = 750 --- 350
            // for 3000ms value will be (3000-1250)/5 = 350 --- 150
            // for 2500ms value will be (2500-1250)/5 = 250 --- 
            // for 2000ms value will be (2000-1250)/5 = 150 
            // for 1000ms value will be (1000-1250)/5 = 0 --- 0 



            const promise = new Promise<void>((resolve) => {
                const timeoutId = setTimeout(() => {
                    this.moveAReelStep2(reelObj, currentRespinIndex, isNewSpin).then(() => {
                        // console.log(`moveAReelStep2 completed for reelIndex: ${reelObj.reelIndex}`);
                        resolve();
                        reelObj.mask.alpha = 0;
                        reelObj.container.mask = null;
                    });
                    clearTimeout(timeoutId);
                }, jurisdictionDelay);
            });

            promises2.push(promise);
        });

        await Promise.all(promises2);

        //await this.jumpAnimGameMultiplier(isSuperQuickBtnOnGlobal);

        await this.allReelStop();

        reelSpinEmitter.emit(EventConstants.REEL_SPIN_DONE);
        console.log("reel spin done");


    }



    public getEffectiveScale(container: Container): { scaleX: number; scaleY: number } {
        let effectiveScaleX = 1;
        let effectiveScaleY = 1;
        let currentContainer = container;

        while (currentContainer) {
            effectiveScaleX *= currentContainer.scale.x;
            effectiveScaleY *= currentContainer.scale.y;
            currentContainer = currentContainer.parent;
        }

        return { scaleX: effectiveScaleX, scaleY: effectiveScaleY };
    }


    protected spinTime: number = 0;
    private setSpinTimeJurisdiction(): number {

        this.spinTime = 0;

        switch (jurisdictionGlobal) {
            //3000ms
            case "colombia":
            case "denmark":
            case "spain":
            case "sweden":
            case "colombia":
            case "bclc":
            case "uk":
            case "ontario":

                this.spinTime = 125;
                break;
            case "lithuania":
                this.spinTime = -50; //5000ms
                break;

            case "germany":
                this.spinTime = 300; //5000ms
                break;
            case "greece":
                this.spinTime = 0; //5000ms
                break;

            //  -- 1000ms

            default:
                this.spinTime = 0;
                break;
        }

        return (this.spinTime);
    }




    protected async allReelStop() {
        // Resolve the promise to signal that all work is done
        if (this.resolveReelsStop) {
            this.resolveReelsStop();
            this.resolveReelsStop = null; // Reset the resolver
        }

    }

    private tweenAccWinValue: Tween<{ x: number }>;


    public setAccWinValue(val: number) {

        const accumWinTextWidth: number = 410;

        let currentVal = this.accuWinVal;
        this.accuWinVal = val;

        this.tweenAccWinValue?.stop(); // stop any previous tween
        this.accumWinText.visible = true;
        if (val === 0) {
            this.accumWinText.text = "";
            // this.winPatch.visible = false;
        }
        else {
            // this.winPatch.visible = true;
            if (currentVal == 0) {
                this.accumWinText.text = this.accuWinVal.toFixed(2);

                this.accumWinText.scale = 1;
                const scale = Math.min(accumWinTextWidth / this.accumWinText.width, 1);
                this.accumWinText.scale.set(scale, scale); // Apply scaling
            }
            else {

                let previousWidth = this.accumWinText.width; // Track the previous width

                this.tweenAccWinValue = new Tween({ x: currentVal }, textTweenGroup)
                    .to({ x: val }, 200)
                    .onUpdate((object) => {
                        currentVal = object.x; // Update currentVal with the tweened value
                        this.accumWinText.text = (currentVal).toFixed(2);

                        // Only apply scaling if the width has changed
                        if (this.accumWinText.width > previousWidth) {
                            this.accumWinText.scale = 1;
                            const scale = Math.min(accumWinTextWidth / this.accumWinText.width, 1);
                            this.accumWinText.scale.set(scale, scale); // Apply scaling

                            // Update the previous width after scaling
                            previousWidth = this.accumWinText.width;
                        }

                    })
                    .onComplete(() => {
                        textTweenGroup.remove(this.tweenAccWinValue);
                        this.accumWinText.text = val.toFixed(2);

                        this.accumWinText.scale = 1;
                        const scale = Math.min(accumWinTextWidth / this.accumWinText.width, 1);
                        this.accumWinText.scale.set(scale, scale); // Apply scaling

                    })
                    .start();

            }

        }

        // this.creditValue.text =  val.toFixed(2);

        // const accWinValueWidth: number = 430;

        // if (val === 0) {
        //     this.tweenAccWinValue?.stop();
        //     this.accumWinText.text = "";
        // }
        // else {

        //     const animate: boolean = Number(this.accumWinText.text) === 0 ? false : true;

        //     if (animate) {

        //         let previousWidth = this.accumWinText.width; // Track the previous width

        //         let currentVal: number = Number(this.accumWinText.text);
        //         this.tweenaccumWinText = new Tween({ x: currentVal }, tweenGroup)
        //             .to({ x: val }, 500)
        //             .onUpdate((object) => {
        //                 currentVal = object.x; // Update currentVal with the tweened value
        //                 this.accumWinText.text = currentVal.toFixed(2);

        //                 // Only apply scaling if the width has changed
        //                 if (this.accumWinText.width > previousWidth) {
        //                     this.accumWinText.scale = 1;
        //                     const scale = Math.min(accumWinTextWidth / this.accumWinText.width, 1);
        //                     this.accumWinText.scale.set(scale, scale); // Apply scaling

        //                     // Update the previous width after scaling
        //                     previousWidth = this.accumWinText.width;
        //                 }

        //             })
        //             .onComplete(() => {
        //                 tweenGroup.remove(this.tweenAccWinValue);
        //                 this.accumWinText.text = val.toFixed(2);

        //                 this.accumWinText.scale = 1;
        //                 const scale = Math.min(accWinValueWidth / this.accumWinText.width, 1);
        //                 this.accumWinText.scale.set(scale, scale); // Apply scaling

        //             })
        //             .start();

        //     }
        //     else {
        //         this.accumWinText.text = val.toFixed(2);

        //         this.accumWinText.scale = 1;
        //         const scale = Math.min(accWinValueWidth / this.accumWinText.width, 1);
        //         this.accumWinText.scale.set(scale, scale); // Apply scaling
        //     }
        // }



    }


}